export default (str) => /^https?:\/\//.test(str);
